import styled from 'styled-components';
import { APP_SHELL_THEME } from '@/styles/appShellTheme';

export const PageContainer = styled.div`
  padding: 24px;
  max-width: 1400px;
  margin: 0 auto;
`;

export const InventoryFilterSection = styled.div`
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid ${APP_SHELL_THEME.panelBorder};
  color: rgba(${APP_SHELL_THEME.overlayRgb}, 0.92);

  .filter-section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    gap: 12px;
  }

  .filter-section-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 600;
    color: rgba(${APP_SHELL_THEME.overlayRgb}, 0.88);
  }

  .filter-section-clear {
    color: ${APP_SHELL_THEME.accent};
    cursor: pointer;
    font-size: 14px;

    &:hover {
      color: rgba(${APP_SHELL_THEME.overlayRgb}, 0.92);
    }
  }
`;

/** Table area matches Rate Cards: transparent shell, unified header row. */
export const InventoryTableSection = styled.div`
  .ant-table {
    background: transparent;
  }

  .ant-table-container,
  .ant-table-content,
  .ant-table-body,
  .ant-table-header {
    background: transparent !important;
  }

  .ant-table-thead > tr > th {
    background: rgba(97, 97, 215, 0.18) !important;
    color: ${APP_SHELL_THEME.tableHeader} !important;
    border-bottom: 1px solid ${APP_SHELL_THEME.panelBorder} !important;
    white-space: nowrap;
  }

  .ant-table-column-sorter,
  .ant-table-column-sorter-up,
  .ant-table-column-sorter-down,
  .ant-table-column-sorter-up.active,
  .ant-table-column-sorter-down.active {
    color: rgba(${APP_SHELL_THEME.overlayRgb}, 0.92) !important;
  }

  .ant-table-thead > tr > th.ant-table-cell-fix-left,
  .ant-table-thead > tr > th.ant-table-cell-fix-right {
    background: ${APP_SHELL_THEME.tableFixedHeaderBg} !important;
  }

  .ant-table-tbody > tr > td {
    background: transparent !important;
    color: rgba(${APP_SHELL_THEME.overlayRgb}, 0.92) !important;
    border-bottom: 1px solid rgba(${APP_SHELL_THEME.overlayRgb}, 0.06) !important;
  }

  .ant-table-tbody > tr:hover > td {
    background: rgba(${APP_SHELL_THEME.overlayRgb}, 0.04) !important;
  }

  .ant-table-tbody > tr > td.ant-table-cell-fix-left,
  .ant-table-tbody > tr > td.ant-table-cell-fix-right {
    background: ${APP_SHELL_THEME.tableFixedBodyBg} !important;
  }

  .ant-table-tbody > tr:hover > td.ant-table-cell-fix-left,
  .ant-table-tbody > tr:hover > td.ant-table-cell-fix-right {
    background: ${APP_SHELL_THEME.tableFixedBodyHoverBg} !important;
  }

  .ant-table-cell-fix-right-first {
    border-left: 1px solid ${APP_SHELL_THEME.panelBorder} !important;
  }

  .ant-table-thead > tr > th.ant-table-cell-fix-right-first::after {
    box-shadow: none !important;
    background: ${APP_SHELL_THEME.tableFixedHeaderBg} !important;
  }

  .ant-table-tbody > tr > td.ant-table-cell-fix-right-first::after {
    box-shadow: none !important;
    background: ${APP_SHELL_THEME.tableFixedBodyBg} !important;
  }

  .ant-table-tbody > tr:hover > td.ant-table-cell-fix-right-first::after {
    background: ${APP_SHELL_THEME.tableFixedBodyHoverBg} !important;
  }

  .ant-table-cell-fix-left-last::after,
  .ant-table-cell-fix-left-last::before,
  .ant-table-cell-fix-right-first::before {
    box-shadow: none !important;
  }
`;
